import React from 'react';
import { disciplines } from '../data/hero';
import { phases, tools } from '../data/system';
export function SystemOverview() {
  return <section aria-label="System overview" className="bg-navy text-white" data-id="element-276" data-mp="18v0mymbbl32b">
      <div className="mx-auto max-w-6xl px-5 py-14 lg:py-20" style={{
      paddingTop: "20px",
      paddingBottom: "22px"
    }} data-id="element-277" data-mp="1mlm8yjw2lt4f">
        <div className="mx-auto max-w-3xl text-center" data-id="element-278" data-mp="1ho47fekdug6g">
          <h2 className="font-display text-3xl font-extrabold uppercase leading-none sm:text-5xl" data-id="element-279" data-mp="txglvqhjns1f">
            The Full Distance Triathlon System™
          </h2>
          <p className="mt-4 text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-280" data-mp="pyhn6nmeorif">
            The complete system for athletes who don't want to piece their preparation together from
            random workouts, disconnected advice and endless tabs.
          </p>
          <p className="mt-5 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 text-sm font-semibold uppercase tracking-wider text-white" data-id="element-281" data-mp="2fa1l8ynthxc2">
            {disciplines.map((d, i) => <React.Fragment key={d} data-id="element-282" data-mp="236w11q4fojw1" data-mpi={i}>
                {i > 0 && <span className="text-aqua" aria-hidden="true" data-id="element-283" data-mp="238gsh6vgbmpo">·</span>}
                <span data-id="element-284" data-mp="2845v5j2rpjq7">{d}</span>
              </React.Fragment>)}
          </p>
          <p className="mt-3 text-sm text-white/50" data-id="element-285" data-mp="2d40jpfz2lx83">Everything you need in a complete 5-in-1 combo</p>
        </div>

        <p className="mt-12 text-center text-xs font-bold uppercase tracking-[0.25em] text-aqua" data-id="element-286" data-mp="2i2lolsp9p52v">
          One system · Six phases · Four performance tools
        </p>

        <ol className="relative mt-8 grid gap-5 lg:grid-cols-6 lg:gap-4" data-id="element-287" data-mp="1peprwnzp7d63">
          <span aria-hidden="true" className="absolute bottom-3 left-[17px] top-3 w-px bg-electric/50 lg:bottom-auto lg:left-[18px] lg:right-[18px] lg:top-[17px] lg:h-px lg:w-auto" data-id="element-288" data-mp="1pcmtbfkhcbpr" />
          {phases.map((p, i) => <li key={p.n} className="relative flex items-start gap-4 text-left lg:flex-col lg:gap-3" data-id="element-289" data-mp="1z6lpzz1sb3ab" data-mpi={i}>
              <span className={i === phases.length - 1 ? 'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-electric font-display text-sm font-bold text-white' : 'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-electric bg-navy font-display text-sm font-bold text-white'} data-id="element-290" data-mp="16ohvspuf1mze">
                {p.n}
              </span>
              <div data-id="element-291" data-mp="18fo9prc6ol7q">
                <p className="font-display text-xl font-bold uppercase leading-tight" data-id="element-292" data-mp="13eiffp2vkpw3">{p.name}</p>
                <p className="mt-0.5 text-sm leading-snug text-white/60" data-id="element-293" data-mp="foxzlf20q8r1">{p.short}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-12 border-t border-white/10 pt-8" data-id="element-294" data-mp="aqwfcqsuw3dz">
          <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-white/50" data-id="element-295" data-mp="pn3z5q0cr2sq">
            Plus 4 performance tools
          </p>
          <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-6 lg:grid-cols-4" data-id="element-296" data-mp="kn7udojtz7c4">
            {tools.map(({
            verb,
            name,
            icon: Icon
          }) => <li key={verb} className="flex items-start gap-3" data-id="element-297" data-mp="1w3fznxqncwrh">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-aqua" aria-hidden="true" data-id="element-298" data-mp="1w2wiij8tmcei" />
                <div data-id="element-299" data-mp="23l44r9n1dy5h">
                  <p className="font-display text-lg font-bold uppercase leading-none text-white" data-id="element-300" data-mp="23p1o9wdj0rpw">{verb}</p>
                  <p className="mt-1 text-xs leading-snug text-white/60" data-id="element-301" data-mp="1um0i5vonv0m8">{name}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}